import React, { createContext, useContext, type ReactNode } from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { SortOrder } from '../../common/types.tsx';

type SortChangeContext = {
	onSortChange?: (field: string, direction: SortOrder) => void;
};

const SortChangeContext = createContext<SortChangeContext | undefined>({});

export const SortChangeContextProvider = componentWithFG(
	'jsc_list_reranking_gate_technical',
	SortChangeContext.Provider,
	({ children }: { children: ReactNode }) => <>{children}</>,
);

export const useSortContext = () => {
	const context = useContext(SortChangeContext);
	return context !== undefined ? context : {};
};
